import { useState } from "react";
import AddTraining from "../modals/AddTraining";
import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title, btnOneNoWidth } from "../utils/style";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";

function Trainings() {
    const [showAddTraining, setShowAddTraining] = useState(false);
    const [modifyTrainingId, setModifyTrainingId] = useState(null);
    const [deleteId, setDeleteId] = useState(null)
    const [reloadTable, setReloadTable] = useState(false)


    async function deleteCourse() {
        try {
            const reqUrl = url + '/course/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
            setReloadTable(1 + Math.random())
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        } finally {
            setDeleteId(null)
        }
    }

    const options = [
        {
            header: 'S. No.',
            key: 'id',
        },
        {
            header: 'Course Name',
            key: 'name',
        },
        {
            header: 'Duration',
            key: 'duration',
        },
        {
            header: 'Link',
            key: 'link',
            render: (data) => {return data.link.length > 20 ? data.link.substring(0, 30) + '...' : data.link }
        },
        {
            header: 'E-Book',
            key: 'ebook'
        },
        {
            header: 'Video',
            jey: 'video'
        },
        {
            header: 'Action',
            render: (data) => {
                return (
                    <>
                        {/* <button 
                            className={'bg-customOne rounded-full p-2 mr-4'}
                        >
                            <img src={edit} height={15} width={15}/>
                        </button> */}
                        <button
                            className={'bg-customOne rounded-full p-2'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </>
                )
            }
        }
    ]

    const excludeFilter = ['E-Book', 'Video', 'Action']

    return (
        <div className="p-4">
            {
                showAddTraining && <AddTraining setShowModal={setShowAddTraining} reload={setReloadTable} />
            }
            {
                deleteId && <ConfirmationModal title={'Training'} setShowForm={setDeleteId} confirm={deleteCourse} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Trainings</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Course`} clickHandler={() => setShowAddTraining(!showAddTraining)} />
                )}
            </div>
            <Table
                options={options}
                url={url + '/courses'}
                pagination
                clickHandler={() => setShowAddTraining(!showAddTraining)}
                btnTitle={'Course'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default Trainings;